import React, { forwardRef,useEffect } from 'react';
import { Box, Grid, Paper, Table, TableBody, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import { StyledTableCellPrint, StyledTableRow } from '../../reusableComponent/Reusables';
import logo from '../../../images/logo-s.png';
import qa_image from '../../../images/logo-s.png';
import qoiImg from '../../../images/print_header.png';
import styles from '.././../../styles.module.css';
import trigaslogo from "../../../images/tri_gases.jpeg";

const QualityEntryPrint = forwardRef(({ printDetails }, ref) => {

    const printData = printDetails;
    console.log('printDetails:', printDetails);
    //const childRows = printDetails.schedule_details || [];
    // const childRows = Array.isArray(printDetails.schedule_details) ? printDetails.schedule_details : [];
    const childRows = (() => {
        try {
            return Array.isArray(printDetails.table_details)
                ? printDetails.table_details
                : JSON.parse(printDetails.table_details || "[]");
        } catch (e) {
            console.error("Failed to parse table_details:", e);
            return [];
        }
    })();

    console.log(childRows)
    const dateConversion = (date) => {
        var today = new Date(date);
        var dd = String(today.getDate()).padStart(2, "0");
        var mm = String(today.getMonth() + 1).padStart(2, "0");
        var yyyy = today.getFullYear();
        const convDate = dd + "/" + mm + "/" + yyyy;
        return convDate;
    };

    return (
        <>

            <Box className="print-source" style={{ margin: '30px' }}  >
                <Paper sx={{ margin: '55px 15px 30px 15px', boxShadow: 'none', height: '90vh', backgroundColor: '#ffffff' }}>
                    <Grid container sx={{}}>
                        <Grid item xs={12} style={{
                            backgroundImage: `url(${qoiImg})`,
                            backgroundRepeat: 'no-repeat',
                            backgroundSize: 'cover',
                            backgroundPosition: 'center',
                            height: '60px',
                            marginBottom: '8px'
                        }}>
                            <Box style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', }}>
                                <Typography sx={{ textAlign: 'start', marginLeft: '50px', marginTop: '10px', fontSize: '26px', fontWeight: 'bold', padding: '1px', color: '#ffffff' }}>
                                    SALES ORDER
                                </Typography>
                                <img src={trigaslogo} style={{ width: 'auto', height: '50px', marginTop: '5px', borderRadius: '2px', border: '2px solid #e10a0a' }} />
                            </Box>
                        </Grid>
                        <Grid item xs={12} >
                            <Grid container>
                                <Grid item xs={8} >
                                    <Typography sx={{ fontWeight: 'bold', fontSize: '18px' }}>
                                        CYLINDER TRACKING SYSTEM (I) Pvt. Ltd.
                                    </Typography>
                                    <Typography sx={{ fontSize: '12px' }}>
                                        Gat No. 333, xyz xyz, Tal. xyz xyz, xyz - 400 008.
                                    </Typography>
                                    <Typography sx={{ fontSize: '12px' }}>
                                        Email - demotes1234@gmail.com
                                    </Typography>
                                    <Typography sx={{ fontSize: '12px' }}>
                                        Website - www.xyz.com / www.xyz.in
                                    </Typography>
                                </Grid>
                                {/* <Grid item xs={4} style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'flex-end',
                                }}>
                                    <img src={qa_image} style={{ width: 'auto', height: '60px', borderRadius: '4px' }} />
                                </Grid> */}
                            </Grid>
                        </Grid>
                        <Grid item xs={12} sx={{ borderTop: '1px solid #616161', backgroundColor: '#f0f0f0', minHeight: '10px', marginTop: '8px' }}>

                        </Grid>
                    </Grid>
                    <Grid container sx={{}}>
                        <Grid item xs={7} >
                            <Box sx={{ minHeight: '100px', margin: '6px', marginLeft: '0px', textAlign: 'left', }}>
                                <Typography sx={{ fontSize: '18px', fontWeight: 'bold', }}>
                                    {printData.customer_name}
                                </Typography>
                                <Typography sx={{ fontSize: '12px', }}>
                                    {printData.customer_address}
                                </Typography>
                            </Box>
                        </Grid>
                        <Grid item xs={5}>
                            <Grid container >
                                <Grid item xs={7} >
                                    <Box sx={{ minHeight: '100px', margin: '6px', marginRight: '0px', textAlign: 'right' }}>
                                        <Typography sx={{ fontSize: '13px' }}>
                                            Entry No
                                        </Typography>
                                        <Typography sx={{ fontSize: '13px' }}>
                                            Entry Date
                                        </Typography>
                                        <Typography sx={{ fontSize: '13px' }}>
                                            Supervisor
                                        </Typography>

                                    </Box >
                                </Grid>
                                <Grid item xs={0.5} >
                                    <Box sx={{ textAlign: 'center', margin: '6px', }}>
                                        <Typography sx={{ fontSize: '13px' }}>:</Typography>
                                        <Typography sx={{ fontSize: '13px' }}>:</Typography>
                                        <Typography sx={{ fontSize: '13px' }}>:</Typography>
                  
                                    </Box>
                                </Grid>
                                <Grid item xs={4.5} sx={{ textAlign: 'right' }}>
                                    <Box sx={{ margin: '6px' }}>
                                        <Typography sx={{ fontWeight: 'bold', fontSize: '13px' }}>{printData.entry_no}</Typography>
                                        <Typography sx={{ fontWeight: 'bold', fontSize: '13px' }}>{dateConversion(printData.entry_date)}</Typography>
                                        <Typography sx={{ fontWeight: 'bold', fontSize: '13px' }}>{printData.quality_supervisor}</Typography>

                                    </Box>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={12} >

                        </Grid>
                    </Grid>
                    <Box style={{ height: '20px' }}> </Box>
                    <>
                        <TableContainer sx={{
                            minWidth: 650,
                            minHeight: 280,
                            padding: '0px 1px 0px 1px'
                        }}>
                            <Table size="small" style={{ borderCollapse: 'collapse' }}>
                                <TableHead>
                                    <TableRow>
                                        <StyledTableCellPrint align="center">Sr No</StyledTableCellPrint>
                                        <StyledTableCellPrint align="left">Cylinder No</StyledTableCellPrint>
                                        <StyledTableCellPrint align="left">Tag No</StyledTableCellPrint>
                                        <StyledTableCellPrint align="left">Product Purity</StyledTableCellPrint>
                                        <StyledTableCellPrint align="left">Settled Pressure</StyledTableCellPrint>
                                        <StyledTableCellPrint align="left">Leak Test</StyledTableCellPrint>
                                        <StyledTableCellPrint align="left">Quality Result</StyledTableCellPrint>
                                        <StyledTableCellPrint align="left">Remarks</StyledTableCellPrint>
                                    </TableRow>
                                </TableHead>

                                <TableBody>
                                    {childRows.map((row, index) => (
                                        <StyledTableRow key={index}>
                                            <StyledTableCellPrint align="center">{row.sr_no}</StyledTableCellPrint>
                                            <StyledTableCellPrint align="left">{row.cyl_no}</StyledTableCellPrint>
                                            <StyledTableCellPrint align="left">{row.tag_no}</StyledTableCellPrint>
                                            <StyledTableCellPrint align="left">{row.product_purity}</StyledTableCellPrint>
                                            <StyledTableCellPrint align="left">{row.settled_pressure}</StyledTableCellPrint>
                                            <StyledTableCellPrint align="left">{row.leak_test}</StyledTableCellPrint>
                                            <StyledTableCellPrint align="left">{row.quality_result}</StyledTableCellPrint>
                                            <StyledTableCellPrint align="left">{row.remarks}</StyledTableCellPrint>
                                        </StyledTableRow>
                                    ))}
                                </TableBody>

                            </Table>
                        </TableContainer>
                    </>
                    <br />
                    <>
                        <Box style={{ borderTop: '1px solid #616161', backgroundColor: '#f0f0f0', minHeight: '10px', }}>
                        </Box>
                        <Box sx={{ textAlign: 'left' }}>
                            <Grid container >
                                <Grid item xs={8} sx={{ minHeight: '130px' }}>
                                    <Box sx={{ textAlign: 'left', padding: '4px 4px 4px 0px' }}>
                                        <Typography sx={{ fontSize: '12px', fontWeight: 'bold' }}>
                                            Terms & Conditions*
                                        </Typography>

                                    </Box>
                                </Grid>
                                <Grid item xs={4} >
                                </Grid>
                            </Grid>
                        </Box>
                        <Grid container >
                            <Grid item xs={12} >
                                <Box sx={{ padding: '4px 14px 4px 4px', }}>

                                    <Typography sx={{ textAlign: 'right', paddingRight: '12px', fontSize: '12px' }}>
                                        For <span style={{ fontWeight: 'bold' }}> CYLINDER TRACKING SYSTEM (I) Pvt Ltd</span>
                                    </Typography>
                                    <Typography sx={{ textAlign: 'right', paddingRight: '12px', fontSize: '12px' }}>
                                        XYZ XYZ XYZ (11234567890)
                                    </Typography>
                                    <br />
                                    <br />
                                    <Typography sx={{ color: '#000000', textAlign: 'right', paddingRight: '12px', fontSize: '12px' }}>
                                        Authorized Signatory
                                    </Typography>
                                </Box>
                            </Grid>
                        </Grid>
                    </>
                </Paper>

            </Box >
        </>
    );
});

export default QualityEntryPrint;
